<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-body">
            <rsa-paziente-armadietto-component @afterSave="onAfterSave" :idAccettazione="idAccettazione" ref="cmpRsaPazienteArmadiettoComponent"></rsa-paziente-armadietto-component>
        </template>
    </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteArmadiettoComponent from "../components/RsaPazienteArmadiettoComponent.vue";
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        utente: { type: Object },
    },
    mixin: [MagazzinoMixins, UtilityMixin],
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteArmadiettoComponent,
    },
    data() {
        return { idAccettazione: null, linkback: "/rsagestioneospiti", linkedit: null, jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {}, documentiCollegati: [] }, pathResource: null, pathResourceAccettazione: "/accettazioni", showModalLoading: false, listKey: 0 };
    },
    created() {},
    mounted() {
        let me = this;
        this.idAccettazione = this.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.showModalLoading = false;
                    this.loadPresidio();
                    this.$refs.cmpRsaPazienteArmadiettoComponent.init(this.jsonData);
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onAfterSave() {
            this.loadAccettazione();
        },
        loadPresidio() {
            let savedPresidio = window.localStorage.getItem("presidio");
            if (!savedPresidio || savedPresidio == "null") {
                let sessionUser = window.sessionStorage.getItem("user");
                if (sessionUser) {
                    let user = JSON.parse(sessionUser);
                    let path = "/utentipresidi";
                    this.loadDataResources(path, { idUtente: user.id }, this.resultResponsePresidio, null);
                }
            }
        },

        resultResponsePresidio(response) {
            let presidio = response.data.data.list.find((item) => item.idPresidio === this.jsonData.idPresidio);
            if (presidio) {
                window.localStorage.setItem("presidio", JSON.stringify(presidio));
            }
        },
    },
};
</script>
